<div class="col-md-12 p-0">
  <div class="modal-header aoe-header-wrap">
    <h3 class="modal-title w-100 admin-model-header-txt p-0">
      <strong class="header-View text-color"> {{data.header}} </strong>
    </h3>
    <img class="d-flex cursor-pointer p-2" mat-dialog-close src="/assets/icons/Close_white.svg" alt="cross" />
  </div>

  <div class="scrollable-content" style="max-height: calc(100vh - 155px); overflow-y: auto;">
    <div class="col-sm-12 text-right" style="padding: 0px 6px;">
      <div class="d-flex justify-content-end align-items-center" style="font-size: 0.75rem !important;">
          <div class="d-flex justify-content-between infoMessage"> <img src="../../assets/icons/tableInfoIcon.svg"
                  class="iconClass mr-2" />
                  <span> Map your Lab's Test Compendium against available {{ sourcetype }}  or Applications external to VitalDx.</span>
          </div>
      </div>
    </div>
    <div autocomplete="off" class="col-sm-12 p-0">
      <div class="col-sm-12 p-0">
        <div *ngIf="!createPage" class="col-sm-12 p-0" >
          <div class="col-sm-12" style="border-bottom: 1px solid #d7d7d7; padding: 5px 20px;display: flex; justify-content: flex-end;">
            <div class="align-center">
              <span class="mr-2">  Auto Release: </span>
              <label class="ct-tag-toggle">
                <input type="checkbox" [(ngModel)]="mainFormOrderCodeFields['EnableAutoRelease']"
                  [value]="mainFormOrderCodeFields['EnableAutoRelease'] == (false || 0 || '') ? false : true">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-12 mt-2 d-flex">
            <div class="viewInputContainer col-sm-3 ">
              <mat-form-field class="col-sm-12 p-0"
                [ngClass]="mainFormOrderCodeFields['instrumentcode'] ? 'valuedField' : ''">
                <mat-label> {{ sourcetype != 'SendOutLabs' ? 'Instrument Code' : 'Target Code' }} </mat-label>
                <input #dynamicFields #field="ngModel" [(ngModel)]="mainFormOrderCodeFields['instrumentcode']"
                  [required]="true" name="Instrument Code" trim matInput [attr.title]="null" [disabled]="true"
                  (input)="isFormChanged = true;"
                  (blur)="trimField('instrumentcode', mainFormOrderCodeFields['instrumentcode'])" />
              </mat-form-field>
            </div>

            <div class="viewSelectContainer col-md-3">
              <mat-form-field class="col-sm-12 p-0">
                <mat-label>Order Code Name</mat-label>
                <mat-select name="OrderCodeName" [panelClass]="'customCEOverlayPanelClass'" #dynamicFields
                  [(ngModel)]="selectedOrderCodeName" (selectionChange)="onOrderCodeNameChange()"  [required]="true"
                  (openedChange)="onDropdownOpened($event)" [compareWith]="compareByName"
                  [disabled]="filteredOrderCodeNameList.length === 0">
                  <div class="search-container p-2" *ngIf="showSearch">
                    <input matInput placeholder="Search..." [(ngModel)]="searchOrderCodeText" 
                      (keyup)="filterOrderCodes($event.target.value)" class="search-input">
                  </div>
                  <mat-option *ngIf="filteredOrderCodeNameList.length === 0" [disabled]="true">
                    No data available
                  </mat-option>
                  <mat-option *ngFor="let dropdownOptions of filteredOrderCodeNameList" [value]="dropdownOptions">
                    <div> {{ dropdownOptions.Name }} </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>


          </div>
          <div class="col-sm-12 mt-4 d-flex">
            <div class="viewInputContainer align-center p-0">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <span class="mr-2">{{ sourcetype != 'SendOutLabs' ? 'Send to Instrument:' : 'Send to Target' }}</span>
                  <div class="d-flex align-items-center">
                    <div class="formTypeSelect defaultTab cursor" [ngClass]="{'active': orderCode === 'OrderCode'}"
                      (click)="toggleInstrumentType('OrderCode')"> <span> Order Code </span> </div>
                    <div class="formTypeSelect advancedTab cursor" [ngClass]="{'active': orderCode === 'ResultCode'}"
                      (click)="toggleInstrumentType('ResultCode')"> <span> Result Code </span> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="viewChipsContainer viewAutoCompleteContainer align-center col-md-3 pl-2">
              <mat-form-field class="col-sm-12 p-0 chip-input-field">
                <mat-label> {{ sourcetype != 'SendOutLabs' ? 'Instrument Result Codes to Ignore' : 'Target Result Codes to Ignore' }}  </mat-label>
                <mat-chip-grid #resultChipGrid aria-label="Enter result codes" class="chip-list">
                  <mat-chip-row *ngFor="let code of instrumentResultCodes" (removed)="removeResultCode(code)">
                    {{code}}
                      <mat-icon matChipRemove>close</mat-icon>
                  </mat-chip-row>
                  <input
                    class="chip-input"
                    [matChipInputFor]="resultChipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addInstrumentResultCode($event)">
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-12 mt-4 d-flex">
            <div *ngIf="orderCode === 'OrderCode'" class="viewChipsContainer viewAutoCompleteContainer align-center col-md-5 pr-2" style="margin-left: 29%;">
              <div style="width: 100%;">
                <div class="row">
                  <div class="col-lg-5 pr-0">
                    <span *ngIf="orderCode == 'OrderCode'">Instrument Order Codes</span>
                    <span *ngIf="orderCode != 'OrderCode'">Target Order Codes</span>
                  </div>
                  <div class="col-lg-5 pr-0">
                    <span>Name</span>
                  </div>
                  <div class="col-lg-2 pr-0">
                    <button title="Add Codes" class="btn btn-primary" (click)="addCodes()" style="width: 32px;">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="row" style="align-items: center;" *ngFor="let code of InsCodes;let i = index;">
                  <div class="col-lg-5 pr-0">
                    <input class="form-control" type="text" id="insorderCode{{i}}" (blur)="InsCodesBlur(i,'Code',$event.target.value)">
                  </div>
                  <div class="col-lg-5 pr-0">
                    <input type="text" class="form-control" id="insorderText{{i}}" (blur)="InsCodesBlur(i,'Name',$event.target.value)">
                  </div>
                  <div class="col-lg-2 pr-0" style="display: flex;">
                    <button *ngIf="i > 0" class="btn btn-danger" style="width: 32px;background: #ef6e6e !important;color: white;border: none;" title="Delete Codes" (click)="removeCodes(code,i)">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- <mat-form-field class="col-sm-12 p-0 chip-input-field">
                                                    <mat-label> {{ sourcetype != 'SendOutLabs' ? 'Instrument Order Codes' : 'Target Order Codes' }}</mat-label>
                                                    <mat-chip-grid #chipGrid aria-label="Enter order codes" class="chip-list">
                                                      <mat-chip-row *ngFor="let code of instrumentOrderCodes" (removed)="removeOrderCode(code)">
                                                        {{code}}
                                                        <mat-icon matChipRemove>close</mat-icon>
                                                      </mat-chip-row>
                                                      <input class="chip-input"  [matChipInputFor]="chipGrid"
                                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addOrderCode($event)">
                                                    </mat-chip-grid>
                                                  </mat-form-field> -->
            </div>
          </div>
        </div>
       
        <div *ngIf="!createPage" class="col-sm-12 row mt-2 mt-2 d-flex justify-content-between align-items-center">
          <div class="col-md-12" style="margin-top: 15px;">
            <app-templates-listing [gridHeader]="listedGridHeader" [gridData]="gridData"
              [context]="'Result Code Mappings'" [hideCreate]="createBtn" [hideEdit]="editBtn" [hideDelete]="deleteBtn"
              (editTemplateClicked)="createResultOrderCodeMapper($event,'edit')"   (deleteTemplateClicked)="deleteResultOrderCodeMapper($event)" [disableToggleEdit]="editBtn" 
              (CreateTemplateClicked)="createResultOrderCodeMapper($event,'create')"  [saveOrEditCompleted]="saveOrEditCompleted" (emitListToggle)="listPageStatusToggleInstrument($event)">
            </app-templates-listing>
          </div>
        </div>

          <div *ngIf="createPage" class='row col-sm-12 m-0 px-2 createFormContainer' [ngClass]="{'vitalDxTest': (sourceApp === 'VitalDx' && isInTest)}">
          <div class="col-sm-6 mt-2 mt-2 d-flex justify-content-between align-items-center">
            <span class="header-Viewcode">
              <strong> {{ action| titlecase }} Result Code Mapper</strong>
            </span>
          </div>
          <form class="float-right col-sm-6 p-0 mt-2 mb-2">
            <div class="p-0 mr-2 button-wrap align-items-center">
              <!-- <a class="reset-btn mr-3" (click)="resetALRForm()" *ngIf="checkIfFormChanged()">Reset</a> -->
              <button class="mr-3 align-center buttonHover" (click)="goBack()" [disabled]="isSaveDisabled"
                tabindex="0">Return</button>
              <button *ngIf="action =='create'"  class="align-center primaryButtonColor d-flex justify-content-space-evenly" tabindex="0" (click)="SaveResultCode()"
                [disabled]="isSaveDisabled">
                Add
              </button>
              <button *ngIf="action!='create'" class="align-center primaryButtonColor d-flex justify-content-space-evenly" tabindex="0" (click)="SaveResultCode()"
              [disabled]="isSaveDisabled">
              Done
            </button>
            </div>
          </form>
          <div autocomplete="off" class="col-sm-12 p-0">
            <div class="col-sm-12 form-wrap-view p-0">
              <div class="col-sm-12 p-0">
                <div *ngIf="orderCode === 'ResultCode'" style="border-bottom: 1px solid #d7d7d7; padding: 5px 20px;display: flex; justify-content: flex-end;">
                  <div class="col-sm-3 align-center">
                    <span class="mr-2"> Use only for Result Mapping: </span>
                    <label class="ct-tag-toggle">
                      <input type="checkbox" [(ngModel)]="mainFormResultCodeFields['resultMapping']"
                        [value]="mainFormResultCodeFields['resultMapping'] == (false || 0 || '') ? false : true">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 d-flex mt-2 p-0">
                  <div class="viewSelectContainer col-sm-3">
                    <mat-form-field class="col-sm-12 p-0">
                      <mat-label>Result Code </mat-label>
                      <mat-select name="resultCodeName" [panelClass]="'customCEOverlayPanelClass'" #dynamicFields
                        [(ngModel)]="selectedResultCodeName" (selectionChange)="onResultCodeNameChange()"  [required]="true">
                        <mat-option *ngIf="ResultCodeNameList.length === 0" [disabled]="true">
                          No data available
                        </mat-option>
                        <mat-option *ngFor="let dropdownResult of ResultCodeNameList" [value]="dropdownResult">
                          <div> {{ dropdownResult.ResultCode }} </div>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-3 viewInputContainer">
                    <mat-form-field class="col-sm-12 p-0">
                      <mat-label>{{ sourcetype != 'SendOutLabs' ? 'Instrument Result Code' : 'Target Result Code' }} </mat-label>
                      <input #dynamicFields #field="ngModel" [(ngModel)]="mainFormResultCodeFields['instrumentResultCodesMapper']" [required]="true"
                        name="Instrument Result Code" trim matInput [attr.title]="null" (input)="isFormResultCodeChanges = true;"
                        (blur)="trimResultField('instrumentResultCodesMapper', mainFormResultCodeFields['instrumentResultCodesMapper'])" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-sm-12 mt-2">
                  <div class="col-sm-12 p-0">
                    <div class="col-md-12 p-0 accept-wrap" style="border-radius: 8px; overflow: hidden;">
                        <div class="col-sm-12 mt-3 mb-3 align-center p-0 d-flex justify-content-between" *ngIf="!showAdditionAttr" style="border-radius: 8px;">
                          <div class="col-md-3 flex-start p-0">
                            <span>Accept Result Properties</span>
                          </div>
                          <!-- Main Result Properties (All, Custom) -->
                          <div class="d-flex flex-row align-items-center mb-2 col-md-9">
                            <div class="mr-4" *ngFor="let ResultProp of ResultProperties" [hidden]="ResultProp.alias === 'None'">
                              <span class="mr-2">{{ ResultProp.name }}:</span>
                              <label class="ct-tag-toggle" style="margin-bottom: 0px;">
                                <input
                                  type="checkbox"
                                  [(ngModel)]="ResultProp.value"
                                  (change)="ResultPropertiesSelect($event, ResultProp,ResultProp.value)"
                                  [value]="ResultProp.alias"
                                />
                                <span class="slider"></span>
                              </label>
                            </div>

                            <div class="row p-0" *ngIf="ShowResultPropertiesTypes">
                              <div class="col-lg-12 d-flex flex-wrap">
                                <div class="mr-2" *ngFor="let RPC of ResultPropertiesCustom; let RPCI = index">
                                  <span class="mr-2">{{ RPC.name }}:</span>
                                  <label class="ct-tag-toggle" style="margin-bottom: 0px;">
                                    <input
                                      type="checkbox"
                                      [(ngModel)]="RPC.value"
                                      (ngModelChange)="ResultPropertiesTypeSelect($event, RPC,RPCI)"
                                    />
                                    <span class="slider"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" style="padding-top: 1.5rem;" *ngIf="showAdditionAttr">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="viewInputContainer col-md-2">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>Crt</mat-label>
                                  <input matInput [(ngModel)]="AttributeCrt" placeholder="example: 25-30" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>CrtSD</mat-label>
                                  <input matInput [(ngModel)]="AttributeCrtSD" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>AmpScore</mat-label>
                                  <input matInput [(ngModel)]="AttributeAmpScore" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>CqConf</mat-label>
                                  <input matInput [(ngModel)]="AttributeCqConf" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2" *ngIf="showSlop">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>Slope</mat-label>
                                  <input matInput [(ngModel)]="AttributeSlop" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2" *ngIf="showeamp">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>eAmp</mat-label>
                                  <input matInput [(ngModel)]="AttributeeAmp" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            
                              <div class="viewInputContainer col-md-2" *ngIf="!isABRGen">
                                <mat-form-field class="col-sm-12 p-0">
                                  <mat-label>Intercept</mat-label>
                                  <input matInput [(ngModel)]="AttributeIntercept" (input)="isFormResultCodeChanges = true;" />
                                </mat-form-field>
                              </div>
                            </div>
                            
                            <div class="col-sm-12 pl-2 mt-3" >
                              <div class="col-sm-12 d-flex mb-2" style="font-weight: 600;">
                                <div class="col-sm-3"></div>
                                <div class="col-sm-6 d-flex justify-content-center">
                                  <div class="col-6 text-center">Range</div>
                                  <div class="col-6 ml-2">Value</div>
                                </div>
                                <div class="col-sm-3"></div>
                              </div>
                            
                              <div *ngFor="let ct of CTRecords; let i = index;" class="col-sm-12 data-row d-flex align-items-center mb-2">
                                <div class="col-sm-3"></div>
                                <div class="col-sm-6 d-flex justify-content-center align-items-center">
                                  <input class="input-wrap mx-2" type="number" [(ngModel)]="ct.range" name="range{{i}}">
                                  <input class="input-wrap mx-2" type="number" [(ngModel)]="ct.value" name="value{{i}}">
                                  <div class="d-flex align-items-center">
                                    <button class="btn btn-primary mx-1" *ngIf="i === 0" style="height: 25px;width: 25px;padding: 0px;display: flex;align-items: center;justify-content: center;" (click)="AddCTRange()">
                                      <i class="fa fa-plus" style="position: relative;top: 2px;"></i>
                                    </button>
                                    <button class="btn btn-danger mx-1" *ngIf="i !== 0" style="height: 25px;width: 25px;padding: 0px;display: flex;align-items: center;justify-content: center;" (click)="RemoveRange(i)">
                                      <i class="fa fa-minus" style="position: relative;top: 2px;"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-sm-3"></div>
                              </div>
                            </div>   
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</div>
<div class="button-wrap">
  <button class="col-sm-1 m-3 align-center primaryButtonColor" (click)="saveChanges()" *ngIf="!createPage">Add Order</button>
</div>
</div>